
import momenttime, { MOMENT_TIME } from '../../momenttime'
import format, { FORMAT } from '../core/format'
import { PAIPAN } from '../core/paipan'
import * as consts from '../base/consts'
import { UTILS } from '../../utils'
import { SHEN_SHA } from '../core/shensha'
import { HE_HUA_CHONG} from '../core/hehuachong'
import { WUXING } from '../core/wuxing'

var FATE_DATA_MANAGER = {
    // 获取八字命盘:命盘信息+运盘信息
    getDetailFateDataByData(data, from) {

        // 特殊处理:Fix:::分享页面type为4,new里面字段不足；
        data.unknown = data.unknown ? data.unknown : 0;
        data.real_time = data.real_time ? data.real_time : 0;

        // 命盘信息
        var starttime = data.real_time != 0 && data.unknown == 0 ? data.realDate : data.birthdayDate;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var baziData = PAIPAN.GetInfo(data.sex, starttime, data.zwzs),
            tiangan = baziData.tg, rigan = tiangan[2];
            console.error('getDetailFateDataByData----', baziData)

        var fateListData = this.getFateListDataByData(data.unknown, baziData, starttime, from);
        var fortuneData = this.getFortuneListByArr(baziData.big_info, baziData.before_info, rigan, from);
        var beforeData = this.getFortuneBeforeData(baziData.before_info, rigan);
        var detailInfoData = this.getDetailInfomationByData(data, baziData);

        console.error('fortuneData-------', beforeData, fortuneData)
        // 把命盘的基础信息，和命盘的四柱八字信息返回
        var result = {
            // 顶部标题栏数据
            "fateInfo": {
                "name": data.f_name,
                "sex": data.sex,
                "zwzs": data.zwzs,
                "rigan": rigan
            },
            // 命盘数据
            "fateListData": fateListData,
            // 大运名称
            "fortuneTitle": fortuneData.title,
            // 大运列表数据
            "fortuneListData": fortuneData.arr,
            "beforeListData": beforeData,
            "detailInfo": detailInfoData
        }
        return result;
    },
    /**
     * 更新八字命盘信息:编辑页联动修改
     * @param {输入表单数据} data 
     */
    updateDetailFateDataByData(data) {
        var starttime = data.real_time != 0 && data.unknown == 0 ? data.real_time : data.birthday;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var baziData = PAIPAN.GetInfo(data.sex, starttime, data.zwzs);

        var fateListData = this.getFateListDataByData(data.unknown, baziData, starttime, 'detail');
        return fateListData;
    },
    // 获取命盘信息
    getFateListDataByData(unknown, baziData, starttime, from) {
        // 生日年月日时信息
        var time = MOMENT_TIME.getTimeArrayByTimeStamp(starttime * 1000),
        year = time[0], month = time[1], day = time[2], hour = time[3], minute = time[4];

        var solarTime = PAIPAN.Solar2Lunar(year, month, day);
        var runStr = solarTime.r == 1 ? "闰" : "";
        var resultArr = [], tiangan = baziData.tg, dizhi = baziData.dz, rigan = tiangan[2];
        // 四柱数据:年柱
        var yearData = {
            id: 'year',
            title: from == 'detail' ? [year + '年', FORMAT.getChineseWordByNumber('year', solarTime.y)] : [year + '年'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[0]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[0], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[0]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[0], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[0]) + FORMAT.getDiZhiByIndex(dizhi[0])
        }
        // 四柱数据:月柱
        var monthData = {
            id: 'month',
            title: from == 'detail' ? [month + '月', runStr + FORMAT.getChineseWordByNumber('month', solarTime.m)] : [month + '月'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[1]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[1], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[1]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[1], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[1]) + FORMAT.getDiZhiByIndex(dizhi[1])
        }
        // 四柱数据:日柱
        var dayData = {
            id: 'day',
            title: from == 'detail' ? [day + '日', FORMAT.getChineseWordByNumber('day', solarTime.d)] : [day + '日'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[2]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[2], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[2]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[2], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[2]) + FORMAT.getDiZhiByIndex(dizhi[2])
        }
        // 四柱数据:时柱
        var hourData = {};
        if(unknown == 1){
            hourData = {
                id: 'hour',
                title: from == 'detail' ? ['时', '辰'] : ['不详'],
                gan: {text: '不', propXingEn: 'no'},
                ganCang: [],
                zhi: {text: '详', propXingEn: 'no'},
                zhiCang: [],
                ganzhi: '不详'
            }
        }else{
            hourData = {
                id: 'hour',
                title: from == 'detail' ? [hour + '时' + minute + '分', FORMAT.getShiChenByNumber(hour)] : [hour + '时' + minute + '分'],
                gan: FORMAT.getTianGanWordDataByIndex(tiangan[3]),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[3], rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[3]),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[3], rigan),
                ganzhi: FORMAT.getTianGanByIndex(tiangan[3]) + FORMAT.getDiZhiByIndex(dizhi[3])
            }
        }
        resultArr.push(yearData);
        resultArr.push(monthData);
        resultArr.push(dayData);
        resultArr.push(hourData);

        // console.log("getFateListDataByData------", time, solarTime)
        // console.log("getFateListDataByData------", year, month, day, hour);
        // console.log("getFateListDataByData------", resultArr);
        return resultArr;
    },
    // 获取命盘资料信息
    getDetailInfomationByData(data, baziData){
        // console.log('getDetailInfomationByData------', data, baziData)
        var niangan = baziData.tg[0], nianzhi = baziData.dz[0];
        
        // 命主资料
        var baseInfo = (niangan%2 == 0 ? '阳' : '阴') + (data.sex == 0 ? '男' : '女') + ' ';
            baseInfo = baseInfo + '肖' + FORMAT.getShengXiaoByNianZhi(nianzhi) + ' ';
            baseInfo = baseInfo + '虚岁' + FORMAT.getXuYearsOldByYear(data.birthday);
        
            // 阳历生日+农历生日
        var time = MOMENT_TIME.getTimeArrayByTimeStamp(data.birthday * 1000),
            y = time[0], m = UTILS.getTimeStrByInt(time[1]), d = UTILS.getTimeStrByInt(time[2]), hh = UTILS.getTimeStrByInt(time[3]), mm = UTILS.getTimeStrByInt(time[4]),
            solarTime = y + '年' + m + '月' + d + '日 ' + hh + ':' + mm + ' ' + FORMAT.getShiChenByNumber(parseInt(hh));
        
            // 农历生日
        var lunarData = PAIPAN.Solar2Lunar(y, time[1], time[2]),
            lunarTime = FORMAT.getChineseWordByNumber('year', lunarData.y) + FORMAT.getChineseWordByNumber('month', lunarData.m) + FORMAT.getChineseWordByNumber('day', lunarData.d)
        
        // 真太阳时
        var realSunTime = '';
        if(data.real_time){
            var real_time = data.realDate == '' ? 0 : MOMENT_TIME.getUnixTimeByTimeStr(data.realDate),
                sun_time = real_time == 0 ? [] : MOMENT_TIME.getTimeArrayByTimeStamp(real_time * 1000);
            if(sun_time.length > 0){
                var y = time[0], m = UTILS.getTimeStrByInt(sun_time[1]), d = UTILS.getTimeStrByInt(sun_time[2]), hh = UTILS.getTimeStrByInt(sun_time[3]), mm = UTILS.getTimeStrByInt(sun_time[4]),
                realSunTime = y + '年' + m + '月' + d + '日 ' + hh + ':' + mm;
            }
        }

        // 出生地区
        var locatData = data.location == '' ? {} : JSON.parse(data.location),
            locatStr = data.location == '' ? '' : locatData.province + locatData.city + locatData.name;
        // 出生时节
        var birthJQArr = [];
            birthJQArr.push([baziData.jieqi.beg.name + '节', FORMAT.getDifferentialDayByNum(time, baziData.jieqi.beg.time)])
            birthJQArr.push([baziData.jieqi.end.name + '节', FORMAT.getDifferentialDayByNum(time, baziData.jieqi.end.time)])
        // 大运开始
        var dayunStrArr = [];
            dayunStrArr.push(baziData.start_desc);
            dayunStrArr.push(UTILS.getDaYunStartTimeStrByData(baziData.begtime));
        // 命局强弱
        var strongStr = data.strong;
        // 命局格局
        var situationStr = data.situation;

        var resultData = {
            baseInfo: baseInfo,
            solarTime: solarTime,
            lunarTime: lunarTime,
            realSunTime: realSunTime,
            locatStr: locatStr,
            birthJQArr: birthJQArr,
            dayunStrArr: dayunStrArr,
            strongStr: strongStr,
            situationStr: situationStr
        };
        return resultData;
    },
    // 获取运盘大运信息
    getFortuneListByArr(bigArr, beforeArr, rigan, from) {
        var resultTitle = "", resultArr = [];
        bigArr.forEach((element, index) => {
            var data = {
                id: element.y,
                index: index,
                year: element.y,
                ganzhi: FORMAT.getTianGanByIndex(element.tg) + FORMAT.getDiZhiByIndex(element.dz),
                type: 'dayun',
                typeBefore: false,
                title: from == 'detail' ? [element.y, element.age + '岁'] : [element.y + '/' + element.age],
                gan: FORMAT.getTianGanWordDataByIndex(element.tg),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', element.tg, rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(element.dz),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', element.dz, rigan),
                choosed: false
            }
            // 是否有批盘的状态:小绿点:迷你命盘
            if(from == 'mini') {
                data.commentEdited = false; data.commented = false;
            }

            // 当前大运
            data.current = false;
            var nowTime = MOMENT_TIME.getTimeArrayByTimeStamp(),
                monthData = PAIPAN.getLiuYue(nowTime[0]),
                // nowData = MOMENT_TIME.getUnixTimeByTimeStr(nowTime[0] + '-' + UTILS.getTimeStrByInt(nowTime[1]) + '-' + UTILS.getTimeStrByInt(nowTime[2]) + ' 00:00:00'),
                // springData = MOMENT_TIME.getUnixTimeByTimeStr(monthData[0].y + '-' + UTILS.getTimeStrByInt(monthData[0].m) + '-' + UTILS.getTimeStrByInt(monthData[0].d + ' 00:00:00')),
                // compData = nowData < springData ? springData : nowData,
                compTime = MOMENT_TIME.getTimeArrayByTimeStamp(monthData * 1000);
            // console.log('getFortuneListByArr----', i, element, nowTime, nowData, springData, compData, compTime)

            // if(nowData >= springData) {
            //     data.current = true;
            // }
            if (index == 0 && compTime[0] < element.y) {
                resultTitle = data.ganzhi;
                // data.current = true;
            }
            if (index <= 9 && compTime[0] >= element.y && compTime[0] < bigArr[index + 1].y) {
                resultTitle = data.ganzhi;
                // data.current = true;
            }
            resultArr.push(data);
        });
        // 只取10个大运
        resultArr.splice(10);

        // 追加一个起运前的数据
        if(from == 'mini' && beforeArr.length > 0) {
            resultArr.forEach((element, index) => resultArr[index].index = index+1)
            var newData = {
                id: beforeArr[0].y,
                index: 0,
                year: beforeArr[0].y,
                ganzhi: '起运前',
                type: 'dayun',
                typeBefore: true,
                title: [beforeArr[0].y + '/' + beforeArr[0].age],
                gan: '',
                ganCang: [],
                zhi: '',
                zhiCang: [],
                choosed: false,
                commentEdited: false,
                commented: false
            }
            resultArr.splice(0, 0, newData);
        }
        console.log("getFortuneListByArr----", resultTitle, resultArr);
        var result = {
            'title': resultTitle,
            'arr': resultArr
        }
        return result;
    },
    // 获取大运前:流年信息
    getFortuneBeforeData(beforeArr, rigan) {
        var resultArr = [];
        for(var i = 0; i < beforeArr.length; i++) {
            var data = {
                id: (beforeArr[i].y + (i + 1) * 10000),
                index: i,
                year: beforeArr[i].y,
                ganzhi: FORMAT.getTianGanByIndex(beforeArr[i]['tg']) + FORMAT.getDiZhiByIndex(beforeArr[i]['dz']),
                type: 'liunian',
                typeBefore: false,
                title: [beforeArr[i].y + '/' + beforeArr[i].age],
                gan: FORMAT.getTianGanWordDataByIndex(beforeArr[i].tg),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', beforeArr[i].tg, rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(beforeArr[i].dz),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', beforeArr[i].dz, rigan),
                choosed: false
            }
            resultArr.push(data);
        }
        return resultArr;
    },
    // 获取八字运盘:流年信息
    getFortuneLiuNianDataByYear(fateInfo, yearData, from) {
        var arr = PAIPAN.getLiuNian(yearData.yearNum)
        var nowYear = (new Date()).getFullYear();
        var resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            var data = {
                id: (arr[i].y + (i + 1) * 10000),
                index: i,
                year: arr[i].y,
                ganzhi: FORMAT.getTianGanByIndex(arr[i]['g']) + FORMAT.getDiZhiByIndex(arr[i]['z']),
                type: 'liunian',
                typeBefore: false,
                title: from == 'detail' ? [arr[i].y, (yearData.startAge + i) + '岁'] : [arr[i].y + '/' + (yearData.startAge + i)],
                gan: FORMAT.getTianGanWordDataByIndex(arr[i].g),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', arr[i].g, fateInfo.rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(arr[i].z),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', arr[i].z, fateInfo.rigan),
                choosed: false
            }
            // 是否有批盘的状态:小绿点:迷你命盘
            if(from == 'mini') {
                data.commentEdited = false; data.commented = false;
            }
            data.current = false;
            // 当前大运
            // if(i == 0 && nowYear < arr[i].y){
            //     data.current = true;
            // }
            // if(i < 9 && nowYear >= arr[i].y && nowYear <= arr[i+1].y){
            //     data.current = true;
            // }
            // if(i == 9 && nowYear == arr[i].y){
            //     data.current = true;
            // }
            resultArr.push(data);
        }
        // console.log("getFortuneLiuNianDataByYear----", resultArr);
        return resultArr;
    },
    // 获取八字运盘:流月信息
    getFortuneLiuYueDataByYear(fateInfo, yearNum, from) {
        var arr = PAIPAN.getLiuYue(yearNum);
        var resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            var data = {
                id: (arr[i].d + (i + 1) * 100 + i),
                index: i,
                time: [arr[i].begtime, arr[i].endtime],
                ganzhi: arr[i].msg,
                type: 'liuyue',
                typeBefore: false,
                title: from == 'detail' ? [(arr[i].m + '-' + arr[i].d), FORMAT.getMonthFestivalByIndex(i)] : [arr[i].m + '-' + arr[i].d],
                gan: FORMAT.getTianGanWordDataByIndex(arr[i].g),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', arr[i].g, fateInfo.rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(arr[i].z),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', arr[i].z, fateInfo.rigan),
                choosed: false
            }
            resultArr.push(data);
        }
        // console.log("getFortuneLiuYueDataByYear----", yearNum, resultArr);
        return resultArr;
    },
    // 获取八字运盘:流日信息
    getFortuneLiuRiDataByYear(fateInfo, yueArr) {
        var arr = PAIPAN.getLiuRi(yueArr[0], yueArr[1]);
        // var length = arr.length >= 31 ? 31 : arr.length;
        var length = arr.length;
        var resultArr = [];
        for (var i = 0; i < length; i++) {
            var data = {
                id: (arr[i].d + (i + 1) * 100 + i),
                index: i,
                g: arr[i].g,
                ganzhi: arr[i].msg,
                type: 'liuri',
                typeBefore: false,
                title: [(arr[i].m + '-' + arr[i].d)],
                key: yueArr[0].toString() + yueArr[1].toString() + arr[i].d.toString() + arr[i].m.toString(),
                gan: FORMAT.getTianGanWordDataByIndex(arr[i].g),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', arr[i].g, fateInfo.rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(arr[i].z),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', arr[i].z, fateInfo.rigan),
                choosed: false
            }
            resultArr.push(data);
        }
        // console.log("getFortuneLiuRiDataByYear----", resultArr);
        return resultArr;
    },
    // 获取八字运盘:流时信息
    getFortuneLiuShiDataByYear(fateInfo, shiTime) {
        var arr = PAIPAN.getLiuRISLiuShi(shiTime);
        var resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            var data = {
                id: (arr[i].beg + arr[i].end + (i + 1) * 100 + i),
                index: i,
                ganzhi: arr[i].msg,
                type: 'liushi',
                typeBefore: false,
                title: [(arr[i].beg + '-' + arr[i].end)],
                key: shiTime.toString() + arr[i].beg.toString() + arr[i].end.toString(),
                gan: FORMAT.getTianGanWordDataByIndex(arr[i].g),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', arr[i].g, fateInfo.rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(arr[i].z),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', arr[i].z, fateInfo.rigan)
            }
            resultArr.push(data);
        }
        // console.log("getFortuneLiuShiDataByYear----", resultArr);
        return resultArr;

    },
    // 八字命盘:右边栏的数据:添加数据
    addFateSideData(subTitle, origiData, addData) {
        var resultData = origiData, tempData;
        tempData = addData;
        switch (tempData.type) {
            case "dayun":
                // tempData.title = ["大运"].concat(tempData.title);
                // tempData.current = false;
                subTitle = subTitle + (tempData.ganzhi + "大运");
                break;
            case "liunian":
                // tempData.title = ["流年"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流年");
                break;
            case "liuyue":
                // tempData.title = ["流月"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流月");
                break;
            case "liuri":
                // tempData.title = ["流日"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流日");
                break;
            default:
                break;
        }
        resultData.push(tempData);
        var result = {
            "title": subTitle,
            "data": resultData
        }
        // console.log("addFateSideData------", result.title, result.data)
        return result;

    },
    // 八字命盘:右边栏的数据:修改数据
    updateFateSideData(subTitle, origiData, newData) {
        // console.log('updateFateSideData-----', subTitle, origiData, newData)
        var resultData = origiData, tempData = Object.assign(newData);
        switch(tempData.type){
            case 'dayun':
                resultData.splice(0, 1);
                resultData[0] = tempData;
                subTitle = tempData.ganzhi + "大运";
                break;
            case 'liunian':
                resultData.splice(1, 1);
                resultData[1] = tempData;
                subTitle = subTitle.slice(0, 7) + tempData.ganzhi + "流年";
                break;
            case 'liuyue':
                resultData.splice(2, 1);
                resultData[2] = tempData;
                subTitle = subTitle.slice(0, 14) + tempData.ganzhi + "流月";
                break;
            case 'liuri':
                resultData.splice(3, 1);
                resultData[3] = tempData;
                subTitle = subTitle.slice(0, 21) + tempData.ganzhi + "流日";
                break;
            default:
                break;
        }
        var result = {
            "title": subTitle,
            "data": resultData
        }
        return result;
    },
    // 八字命盘:右边栏的数据:删除数据
    deleteFateSideData(subTitle, origiData, deleteData) {
        var resultData = origiData, tempData, showType;
        tempData = deleteData;
        showType = tempData.type;
        switch (tempData.type) {
            case "dayun":
                resultData = [];
                subTitle = "";
                break;
            case "liunian":
                resultData.splice(1, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流年") - 5));
                break;
            case "liuyue":
                resultData.splice(2, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流月") - 5));
                break;
            case "liuri":
                resultData.splice(3, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流日") - 5));
                break;
            default:
                break;
        }
        var result = {
            "type": showType,
            "title": subTitle,
            "data": resultData
        }
        // console.log("deleteFateSideData------", resultData, result)
        return result;
    },
    // 八字运盘:更新列表元素的当前选中状态
    updateFortuneListDataChoosed(origiData, newData) {
        var curIndex = UTILS.getIdIndexInObjectArray(origiData, newData.id);
        origiData.forEach((data, index) => {
            data.choosed = false;
            if(index == curIndex) {
                data.choosed = true;
            }
        });
        return origiData;
    },
    // 迷你运盘:根据年份获取Data数据:大运or流年
    getFortuneItemDataByYear(origiData, year) {
        for(var data of origiData) {
            if(data.year == year){
                return data
            }
        }
        return null;
    },
    // 四柱起盘:获取当前时间的八字
    getCurrentEightWordArr(formData) {
        var sex = formData.sex != '' ? parseInt(formData.sex) : 0, zwzs = formData.zwzs != '' ? parseInt(formData.zwzs) : 1, time = formData.birthday;
        var baziData = PAIPAN.GetInfo(sex, time, zwzs);
        var eightWordArr = FORMAT.getSiZhuEightWordArr(baziData);
        // console.log('getCurrentEightWordArr----', sex, zwzs, time, baziData, eightWordArr)
        return eightWordArr;
    },
    // 四柱起盘:获取与当前八字四柱相同的时间列表
    getSameEightWordList(eightWordArr) {
        var start = consts.CONST_START_END_YEAR[0], end = consts.CONST_START_END_YEAR[1], tg = [], dz = [];
        for(var arr of eightWordArr) {
            tg.push(FORMAT.getTianGanIndexByText(arr[0].text));
            dz.push(FORMAT.getDiZhiIndexByText(arr[1].text));
        }
        var resultList = [], sameGanZhiList = PAIPAN.GetSameGanZhiList(tg, dz, start, end);
        for(var list of sameGanZhiList) {
            var y = parseInt(list.y), 
                m = list.m < 10 ? '0' + list.m : list.m, 
                d = list.d < 10 ? '0' + list.d : list.d, 
                h = list.h < 10 ? '0' + list.h : list.h,
                mi = list.i < 10 ? '0' + list.i : list.i,
                s = list.s < 10 ? '0' + list.s : list.s;
            var solarTime = PAIPAN.Solar2Lunar(parseInt(y), parseInt(m), parseInt(d));
            var runStr = solarTime.r == 1 ? "闰" : "";
            var data = {
                text_one: y + '年' + m + '月' + d + '日 ' + h + ':' + mi,
                text_two: '农历: ' + FORMAT.getChineseWordByNumber('year', solarTime.y) + runStr + FORMAT.getChineseWordByNumber('month', solarTime.m) + FORMAT.getChineseWordByNumber('day', solarTime.d) + ' ' + FORMAT.getShiChenByNumber(parseInt(h)),
                chaodai: y >= 1949 ? '' : PAIPAN.GetNianHao(y), // 当代的不显示朝代年号这些信息
                selected: sameGanZhiList.indexOf(list) == 0 ? true : false,
                birthday: MOMENT_TIME.getUnixTimeByTimeStr(UTILS.formatYearNum(y) + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s)
            }
            resultList.push(data);
        }
        console.log('getSameEightWordList----', eightWordArr, tg, dz, sameGanZhiList, resultList)
        return resultList;
    },
    // 四柱起盘:修改八字四柱列表数据，并更新与更新后的八字四柱相同的时间列表
    updateEightWordArrByData(origiList, pos, newData) {
        // 更新八字数据
        if(origiList[pos[0]][pos[1]]) {
            origiList[pos[0]][pos[1]] = Object.assign({}, newData);
        }
        return origiList;
    },
    // 命盘页:获取神煞
    getDetailShenShaListByList(fateList, allList){
        console.log('getShenShaListByList------', fateList, allList);
        var fateSiZhu = [], allZhu = [];
        fateList.forEach(data => {
            fateSiZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        allList.forEach(data => { 
            allZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        var resultList = SHEN_SHA.getAllListShenSha(fateSiZhu, allZhu);
        return resultList;
    },
    // 命盘页:获取合化冲关系
    getDetailRealationListByList(fateList, allList){
        var fateSiZhu = [], allZhu = [];
        fateList.forEach(data => {
            fateSiZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        allList.forEach(data => { 
            allZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        var resultList = HE_HUA_CHONG.getAllListHeHuaChong(allZhu);
        return resultList;
    },
    // 获取**生在**月的文本
    getFateTextByData(data) {
        var rigan = FORMAT.getTianGanByIndex(data.tg_3) + WUXING.getWuXingByIndex(WUXING.getTianGanXingByIndex(data.tg_3)),
            yuezhi = FORMAT.getDiZhiByIndex(data.dz_2) + WUXING.getWuXingByIndex(WUXING.getDiZhiXingByIndex(data.dz_2));
        return rigan + '生在' + yuezhi + '月';
    },
    // 获取前一个数据
    getPreviousDataInList(listData, curData) {
        var resultData = [], len = listData.length;
        for(var i = 0; i < len; i++) {
            if(listData[i].id == curData.id) {
                resultData = i > 0 ? listData[i-1] : listData[0];
                return resultData;
            }
        }
        return resultData;
    },
    // 获取后一个数据
    getNextDataInList(listData, curData) {
        var resultData = [], 
            len = curData.type == 'dayun' ? 10 : listData.length;
        for(var i = 0; i < len; i++) {
            if(listData[i].id == curData.id) {
                resultData = i < len-1 ? listData[i+1] : listData[len-1];
                return resultData;
            }
        }
        return resultData;
    },
    getFortuneItemDataByLiunian(listData, liunian) {
        for(var i = 0; i < listData.length; i++) {
            if(parseInt(listData[i].year) <= parseInt(liunian) && parseInt(listData[i].year) + 10 > parseInt(liunian)) {
                return listData[i];
            }
        }
        return null;
    },
    getFortuneItemDataByItemId(listData, dataId) {
        for(var i = 0; i < listData.length; i++) {
            if(listData[i].year == dataId) {
                return listData[i];
            }
        }
        return null;
    }
}

export {
    FATE_DATA_MANAGER
}